function registerSW() {
  if (process.env.NODE_ENV !== 'production') return
  if (!('serviceWorker' in navigator)) return

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(`${process.env.BASE_URL}service-worker.js`)
      .then(() => {
        // eslint-disable-next-line no-console
        console.log('[PWA] Service worker registered.')
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('[PWA] Service worker registration failed:', error)
      })
  })
}

registerSW()
